<mat-card  *ngIf="selectedApp" class="flx-card wd-mx crd-ovrflw bottom-card-ht"  style="max-height:530px; overflow-y:auto;">
  <mat-card-header class="grp_hdr">
      <article [ngClass]="['header-padding']">
          <div fxLayout="column" fxLayoutAlign="start center">
              <h4 ngClass="selectlist-label" *ngIf="listDateRange === 'monthSelected'">Last 24 Month's Data</h4>
              <h4 ngClass="selectlist-label" *ngIf="listDateRange === 'daySelected'">Last 1 Month's Data</h4>
              <h4 ngClass="selectlist-label" *ngIf="listDateRange === 'yearSelected'">Last 5 Year's Data</h4>
          </div>
          <nav class="nv_rt rpd">
            <div fxLayout="row" fxLayoutGap="10px">
              <div fxLayout="column" fxLayoutAlign="end center">
                  <div fxLayout="row">
                      <h4 ngClass="selectlist-label" *ngIf="menuSelectedButton !== 'totalSessionPlayed' &&
                      menuSelectedButton !== 'totalSessionDurationAvg' &&
                      menuSelectedButton!=='totalUsers' && menuSelectedButton === 'all'">
                      Usage : </h4>
                      <h4 ngClass="selectlist-label" *ngIf="menuSelectedButton === 'totalSessionPlayed'">Total Sessions :
                      </h4>
                      <h4 ngClass="selectlist-label" *ngIf="menuSelectedButton === 'totalSessionDurationAvg'">Average Session Duration :
                      </h4>
                      <h4 ngClass="selectlist-label" *ngIf="menuSelectedButton === 'totalUsers'">Users :</h4>
                      <mat-form-field id="duration-dropdown" class="drpdown-chart-options" appearance="outline">
                          <mat-select [(ngModel)]="usageAnalyticsSelectedValue" name="usageAnalytics"
                              (selectionChange)="changeAnalytics($event.value)">
                              <mat-option class="drp-options" *ngFor="let ua of usageAnalytics" [value]="ua.value">
                                  {{ua.viewValue}}
                              </mat-option>
                          </mat-select>
                      </mat-form-field>
                  </div>
              </div>
              <div fxLayout="column">
                <i class="fa fa-share-square-o" aria-hidden="true" style="font-size: 24px;margin-top:8px; color: #707070; cursor: pointer;" (click)="exportCsvData('usage')"></i>
              </div>
            </div>
          </nav>
      </article>
  </mat-card-header>
  <mat-card-content class="flx_tm" >
      <mat-spinner *ngIf="sessionPlayedChartDatasets.length == 0" diameter="20" ngClass="loader"></mat-spinner>

      <div id="canvas-container">
          <app-highcharts [totalLessionsSessions]="totalLessionsSessions" [updateChart]="updateChart"></app-highcharts>
      </div>
          
          <ng-container *ngIf="toShowExpandText">
              <div (click)="chartClick($event)" class="label" *ngFor="let label of sessionPlayedChartLabels; let i = index" [ngClass]="{'custom-margin-1': i === 0, 'custom-margin-2': i === 1, 'custom-margin-3': i === 2, 'custom-margin-4': i === 3}">
                  <span class="constant-text" *ngIf="i < sessionPlayedChartLabels.length - 1">{{ expandText }}</span>
              </div>
          </ng-container>

          <div *ngIf="isExpanded" class="timeline-container"> 
              <div>
                  <div class="timeline-bar"> 
                      <div class="progress" [ngStyle]="{'margin-left': getMarginLeft()}"></div> 
                  </div> 
                  <ul class="years"> 
                      <li *ngFor="let item of last5Years">{{ item }}</li> 
                  </ul> 
              </div>
              <button class="see-all" (click)="yearSelected(); this.isExpanded = false;">See All</button> 
          </div>
  </mat-card-content>
</mat-card>